import type { IconNode } from '../types';

/**
 * @name tic-tac-toe
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMnYyMCIgLz4KICA8cGF0aCBkPSJtMjEgMTYtNSA1IiAvPgogIDxwYXRoIGQ9Im0yMSAyMS01LTUiIC8+CiAgPHBhdGggZD0iTTIyIDEySDIiIC8+CiAgPHBhdGggZD0iTTggMyAzIDgiIC8+CiAgPHBhdGggZD0iTTggOCAzIDMiIC8+CiAgPGNpcmNsZSBjeD0iMTguNSIgY3k9IjUuNSIgcj0iMi41IiAvPgogIDxjaXJjbGUgY3g9IjUuNSIgY3k9IjE4LjUiIHI9IjIuNSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/tic-tac-toe
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const TicTacToe: IconNode = [
  ['path', { d: 'M12 2v20' }],
  ['path', { d: 'm21 16-5 5' }],
  ['path', { d: 'm21 21-5-5' }],
  ['path', { d: 'M22 12H2' }],
  ['path', { d: 'M8 3 3 8' }],
  ['path', { d: 'M8 8 3 3' }],
  ['circle', { cx: '18.5', cy: '5.5', r: '2.5' }],
  ['circle', { cx: '5.5', cy: '18.5', r: '2.5' }],
];

export default TicTacToe;
